exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__shader___1TzJm{z-index:49;width:100vw;height:100vh;background:#1e265c;position:fixed;top:0;left:0}", ""]);

// exports
exports.locals = {
	"shader": "index-module__shader___1TzJm"
};